import React from 'react';

const IncomeRules = () => {
  const coins = <img
    className={'policy-description-icon policy-description-icon-margin-right-left'}
    src={'/img/icons/coins.png'}
    alt={'Монеты'}
    title={'Монеты'}
  />;
  const winPoints = <img
    className={'policy-description-icon policy-description-icon-margin-right-left'}
    src={'/img/icons/win points.png'}
    alt={'Очки'}
    title={'Очки'}
  />;
  const mine = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-right-left'}
    src={'/img/hexes/mine.ecae90cd.png'}
    alt={'Рудник'}
    title={'Рудник'}
  />;
  const ruins = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-right-left'}
    src={'/img/hexes/ruins.65862e11.png'}
    alt={'Руины'}
    title={'Руины'}
  />;
  const guild = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-right-left'}
    src={'/img/hexes/special buildings/guild.ee26d2b8.png'}
    alt={'Гильдия'}
    title={'Гильдия'}
  />;
  const city = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-right-left'}
    src={'/img/icons/city.42008716.png'}
    alt={'Город'}
    title={'Город'}
  />;
  const temple = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-right-left'}
    src={'/img/hexes/special buildings/temple.17c08b3d.png'}
    alt={'Храм'}
    title={'Храм'}
  />;

  return (
    <div className="rules-page_content">
      <h2 className="rules-page_title text-coins-dark">
        Доход
      </h2>

      <div className="rules-page_section">
        <p>В конце раунда игроки получают доход:</p>
        <ul>
          <li>Базовый доход: 2 монеты {coins} — если у игрока есть хотя бы 1 город {city}.</li>
          <li>Доход монет {coins} с рудников {mine} и Гильдий {guild}.</li>
          <li>Доход очков {winPoints} с руин {ruins} и Храмов {temple}.</li>
        </ul>
        <p>
          Дополнительная монета лепреконов начисляется на тех же условиях, что и базовый доход: только пока у игрока
          есть хотя бы 1 город {city}. Если в конце раунда у игрока не осталось ни одного города, его монеты сгорают
          (см. «Захват города» в разделе «Очки за действия»).
        </p>
        <p>
          Бонус к доходу монет {coins} (у ботов, см. раздел «Боты», в лобби с бонусом для всех игроков и в локальной
          игре — тому, кому его выбрали) складывается из двух частей. Первая — одна и та же у всех уровней бонуса и
          начисляется, как базовый доход, пока у игрока есть хотя бы 1 город {city}. Вторая — у старших уровней — за
          каждый город {city}, которым владеет игрок, даже если кварталы города заблокированы. Без городов бонуса нет.
          Уровень бонуса «божество» (у божественных ботов и в локальной игре) дает еще и очки победы {winPoints}
          к доходу — тоже за каждый город.
        </p>
        <p>
          Заблокированные ключевые точки и строения дохода не приносят (см. «Блокировка строений и ключевых точек» в
          разделе «Обзор игры»). На бонус к доходу за города блокировка не влияет.
        </p>
        <p>
          В последних 3 раундах игры (с 11 по 13) руины {ruins} приносят <b>удвоенный</b> доход очков {winPoints}.
        </p>
      </div>
    </div>
  );
};

export default IncomeRules;
